/* eslint-disable */
import getPeopleDetailByUin from './getPeopleDetailByUin';
import getTroopDetailById from './getTroopDetailByIdForRecent';

export default function(params) {
    const peopleIds = [];
    const troopIds = [];
    const discussIds = [];
    const result = {
        people: {},
        troop: {},
        discuss: {}
    };

    params.list.forEach(item => {
        switch (item.metaSourceType || item.sourceType) {
            case 'people':
                peopleIds.push(item.id);
                break;
            case 'troop':
                troopIds.push(item.id);
                break;
            case 'discuss':
                discussIds.push(item.id);
                break;
        }
    });

    return new Promise((resolve, reject) => {
        _getDiscussFaceById({
            ids: discussIds
        })
            .then(list => {
                list.forEach(item => {
                    result.discuss[item.id] = {
                        name: item.name,
                        face:
                            'https://bqq.gtimg.com/qidian-stellaris-mobile/public-assets/contact-selector/discuss_default_avatar.png'
                    };
                });
                return getPeopleDetailByUin({
                    ids: peopleIds
                });
            })
            .then(list => {
                result.people = list;
                return getTroopDetailById({
                    ids: troopIds
                });
            })
            .then(list => {
                list.forEach(item => {
                    result.troop[item.uin] = {
                        name: item.name,
                        face: item.face
                    };
                });
                resolve(result);
            })
            .catch(err => {
                reject(err);
            });
    });
}

function _getDiscussFaceById(params) {
    const list = params.ids;
    return new Promise((resolve, reject) => {
        const result = [];
        list.forEach(item => {
            result.push({
                id: item,
                face: ''
            });
        });
        resolve(result);
    });
}
